import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { useFpId } from '../hooks/useFpId';
import { queryKeys } from './queryKeys';
import { GoalsSummaryDTO } from '../types/goalsSummaryDTO';

interface FetcherParams {
  clientId: number;
  fpId: string | null;
}

export const fetchGoalsSummary = async ({
  clientId,
  fpId,
}: FetcherParams): Promise<{ GoalsSummary: GoalsSummaryDTO[] }> => {
  return authFetch(
    urlWithParams('/Consumer/GoalsSummary', {
      clientId,
      fpId,
    }),
  );
};

export const useGoalsSummaryQuery = () => {
  const clientId = useClientId();
  const fpId = useFpId();

  return useQuery(
    queryKeys.goalsSummary(clientId, fpId),

    () => fetchGoalsSummary({ clientId, fpId }),

    {
      enabled: !!fpId,
      cacheTime: 0,
    },
  );
};
